import LegalDocumentPage from '@/components/legal/LegalDocumentPage';

export default function TermsPage() {
  return <LegalDocumentPage documentKey="terms" headingId="terms-page-heading" />;
}
